<template>
  <header class="common-header" id="header">
    <h1 class="header-title">
      <a href="/dashboard">
        <template v-if="appClass === 'sumitomolife'">
          <img  class="header-logo" src="./assets/logo-sumitomolife.png" alt="ロゴ" />
        </template>
        <template v-else-if="appClass === 'osaka'">
          <img class="header-logo" src="./assets/logo-white@2x.png" alt="ロゴ" /> for 大阪国際がんセンター AYA世代
        </template>
        <template v-else-if="appClass === 'hama'">
          <img class="header-logo" src="./assets/logo-hama.svg" alt="ロゴ" />
        </template>
        <template v-else>
          <img class="header-logo" src="./assets/logo-white@2x.png" alt="ロゴ" />
        </template>
        <span v-if="isAdviser"><font size="1" :color="headerTextColor">【アドバイザー】</font></span><span v-if="isStaff"><font size="1" :color="headerTextColor">【運営】</font></span></a>
      <font :color="headerTextColor">
        <template v-if="env === 'dev'"> - dev環境</template>
        <template v-if="env === 'feature'"> - 案件確認環境</template>
        <template v-if="env === 'design'"> - design環境</template>
        <template v-if="env === 'staging'"> - staging環境</template>
      </font>
    </h1>
    <div class="header-menu" v-if="signedIn">
      <span class="header-button" @click="naviOpen">
        <template v-if="appClass === 'sumitomolife'">
          <img src="./assets/navigation-menu-sumitomolife.svg" alt="メニュー" />
        </template>
        <template v-else>
          <img src="./assets/navigation-menu.svg" alt="メニュー" />
        </template>
      </span>
      <ul class="menu-body" v-if="active">
        <li><a :href="'/profile/' + id">プロフィール</a></li>
        <li><amplify-sign-out /></li>
      </ul>
    </div>
    <div class="header-notice" v-if="signedIn">
      <a class="header-button" href="/noticeList">
        <template v-if="appClass === 'sumitomolife'">
          <img src="./assets/alarm-sumitomolife.svg" alt="通知" />
        </template>
        <template v-else>
          <img src="./assets/alarm.svg" alt="通知" />
        </template>
      </a>
    </div>
  </header>
</template>
<script scoped>
import { Common } from './Common.js'
export default {
  props: ['signedIn', 'isAdviser', 'isStaff', 'id'],
  mixins:[Common],
  data: () => {
    return {
      active: false,
      appClass: '',
      headerTextColor: 'white',
    }
  },
  head: {
    script: function () {
      let twitterUniversalWebsiteTagCode = {
        type: 'text/javascript', 
        inner: `
          !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
          },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
          a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
          // Insert Twitter Pixel ID and Standard Event data below
          twq('init','o9llj');
          twq('track','PageView');
        `
      }
      let facebookPixelCode = {
        type: 'text/javascript', 
        inner: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window,document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '438046634892640'); 
          fbq('track', 'PageView');
        `
      }
      return [twitterUniversalWebsiteTagCode, facebookPixelCode]
    }
  },
  methods: {
    naviOpen() {
      this.active = !this.active
    }
  },
  mounted : function(){
    this.appClass = this.getAppDivClass(location.hostname)
    if (this.appClass === 'sumitomolife') {
      this.headerTextColor = 'black'
    }
  },
  async beforeCreate() {
    if (location.hostname === 'dev.d2q78m2xs8yfz1.amplifyapp.com' || location.hostname === 'localhost') {
      this.env = 'dev'
    } else if (location.hostname.match(/^feature-.*\.d2q78m2xs8yfz1\.amplifyapp\.com$/)) {
      this.env = 'feature'
    } else if (location.hostname === 'design.d2q78m2xs8yfz1.amplifyapp.com') {
      this.env = 'design'
    } else if (location.hostname === 'staging.d2q78m2xs8yfz1.amplifyapp.com') {
      this.env = 'staging'
    } else if (location.hostname === 'payment.d2q78m2xs8yfz1.amplifyapp.com') {
      this.env = 'dev'
    }
  }
}
</script>
<style>
</style>
